
import { createAsyncThunk } from '@reduxjs/toolkit';
import productApi from '../../utils/api/productApi';
import sizeApi from '../../utils/api/sizeApi';

  export const fetchProducts = createAsyncThunk(
    'products/fetchProducts',
    async (params) => {
      const products = await productApi.getProducts(params);
      return products;
    }
  );

  export const fetchProductById = createAsyncThunk('products/fetchProductById', async ({ params }) => {
    const product = await productApi.getProduct(params);
    return product;
  });
  
  export const createProduct = createAsyncThunk('products/createProduct', async (product) => {
    const createdProduct = await productApi.addProduct(product);
    return createdProduct;
  });
  
  export const updateExistingProduct = createAsyncThunk(
    'products/updateExistingProduct',
    async ({ productId, product }) => {
      const updatedProduct = await productApi.updateProduct(productId, product);
      return updatedProduct;
    }
  );
  
  export const removeProduct = createAsyncThunk('products/removeProduct', async (productId) => {
    const deletedProduct = await productApi.deleteProduct(productId);
    return deletedProduct;
  });